import React, { useState } from "react";
import { getDayMonth } from "../../../js/helpers/dateHelpers";
import CandidateProfile from "./CandidateProfile";
import useFirestoreDoc from "../../../app/hooks/useFirestoreDoc";
import {
  listenToDocFromFirestore,
  toggleSettingInDocument,
} from "../../../app/firestore/firestoreService";
import {
  FIRESTORE_APPLICATIONS_COLLECTION,
  FIRESTORE_CANDIDATE_PROFILES_COLLECTION,
  QUERY_CODES,
} from "../../../app/firestore/firestoreConstants";
import { useDispatch } from "react-redux";
import trashHoverIcon from "../../../assets/icons/trash-hover-icon.svg";
import { openModal } from "../../../app/common/modals/modalReducer";
import { DELETE_APPLICATION_CONFIRM_MODAL } from "../../../app/common/modals/ModalManager";
import { Button, Icon } from "semantic-ui-react";

export default function ReviewApplication({ application, isAdmin = false }) {
  const dispatch = useDispatch();

  const [candidateProfile, setCandidateProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useFirestoreDoc({
    query: () =>
      listenToDocFromFirestore({
        dbCollection: FIRESTORE_CANDIDATE_PROFILES_COLLECTION,
        id: application.candidateProfileId,
      }),
    data: (profile) => setCandidateProfile(profile),
    deps: [dispatch, application],
    queryCode: QUERY_CODES.listenToCompanyProfileFromFirestore,
  });

  async function handleContactedButton() {
    try {
      setIsLoading(true);
      await toggleSettingInDocument({
        dbCollection: FIRESTORE_APPLICATIONS_COLLECTION,
        id: application.id,
        key: "isContactedByEmployer",
        toggle: application.isContactedByEmployer,
      });
    } catch (e) {
      console.log("error setting application contacted");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div
      className="teal-box-container body-blue-text"
      style={{ marginTop: 24 }}
    >
      <div className="grey-row-bar">
        <span>
          Applied: {getDayMonth(application.dateApplied)} <br />
          Job location: {application.jobLocationAddress}
        </span>
        {isAdmin && (
          <span className="float-right">
            <span>{application.id}</span>
            <span style={{ marginLeft: 15 }}>
              {application.isDeletedByEmployer && "Deleted"}
            </span>
          </span>
        )}
        {!isAdmin && (
          <span className="float-right">
            <Button
              className={"overwrite-button icon-text-button"}
              content={<span className={"action-text"}>Contacted</span>}
              icon={
                application.isContactedByEmployer ? (
                  <Icon name="check square outline" />
                ) : (
                  <Icon name="square outline" />
                )
              }
              onClick={handleContactedButton}
              loading={isLoading}
              style={{ margin: "0 20px 0 0" }}
            />
            <Button
              className={"overwrite-button icon-text-button"}
              content={<span className={"action-text"}>Delete</span>}
              icon={
                <img
                  className={"icon-text-button-img"}
                  src={trashHoverIcon}
                  style={{ width: 12, height: 14 }}
                  alt="delete"
                />
              }
              onClick={() =>
                dispatch(
                  openModal({
                    modalType: DELETE_APPLICATION_CONFIRM_MODAL,
                    modalProps: { application: application },
                  })
                )
              }
            />
          </span>
        )}
      </div>
      {candidateProfile && (
        <CandidateProfile
          candidateProfile={candidateProfile}
          padding={"12px 18px 8px"}
          isEmployer={true}
          applicationCoverLetter={
            application.coverLetter && application.coverLetter.url
          }
        />
      )}
    </div>
  );
}
